import { render, staticRenderFns } from "./LaptopSvg.vue?vue&type=template&id=0ccace6a&scoped=true&"
import script from "./LaptopSvg.vue?vue&type=script&lang=js&"
export * from "./LaptopSvg.vue?vue&type=script&lang=js&"
import style0 from "./LaptopSvg.vue?vue&type=style&index=0&id=0ccace6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccace6a",
  null
  
)

export default component.exports